import React from "react";
import { useState, useEffect } from "react";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import NewDynamic_PR_table from "../../../../components/NewDynamic_PR_Table";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const PR_Status = () => {
  const navigate = useNavigate();

  const [reportList, setReplortList] = useState([]);
  const [appraisalCycle, setAppraisalCycle] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [statusl, setStatus] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [respStatus,setRepStatus]= useState(0);
  const [loading, setLoading] = useState("");

  useEffect(() => {
    fetchReportList();
  }, [searchTerm]);

  const fetchReportList = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/6?P_AppraisalCycleID=${0}&P_EmployeeID=${0}&P_IsSaveAsDraft=${0}`
      );
      setReplortList(response?.data?.header);

      const cycleOpts = response?.data?.appraisalCycle?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      cycleOpts.unshift({ value: 0, label: "Select" });
      setAppraisalCycle(cycleOpts);

      const employetOpts = response?.data?.employeeList?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      employetOpts.unshift({ value: 0, label: "Select" });
      setEmployee(employetOpts);

      const statuslist = Object.entries(response.data.statusList).map(
        ([key, value]) => ({
          value: key,
          label: value,
        })
      );

      statuslist.unshift({ value: 0, label: "Select" });
      setStatus(statuslist);
      setRepStatus(response.status);
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("PR Status"))
  }, [])

  const columns = {
    Employee: { text: "Employee", visible: true },
    SubmittedDate: { text: "Submitted Date", align: "center", visible: true },
    Status: { text: "Status", align: "center", visible: true },
  };
  const defaultColumns = {
    Employee: true,
    SubmittedDate: true,
    Status: true,
  };

  const formDatas = [
    {
      name: "Appraisal Cycle",
      type: "Select",
      options: [...appraisalCycle],
    },
    {
      name: "Status",
      type: "Select",
      options: [...statusl],
    },
    {
      name: "Employee",
      type: "Select",
      options: [...employee],
    },
  ];

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/6?P_AppraisalCycleID=${
          filterFormData.find((o) => o.label === "Appraisal Cycle")
            ? filterFormData.find((o) => o.label === "Appraisal Cycle").value
            : 0
        }&P_EmployeeID=${
          filterFormData.find((o) => o.label === "Employee")
            ? filterFormData.find((o) => o.label === "Employee").value
            : 0
        }&P_IsSaveAsDraft=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : 0
        }`
      );
      if (response.status === 200) {
        const cleanedData = response.data.header;
        
        setReplortList(cleanedData);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleView = (id) => {
    navigate(`/pr-evaluation-report/${id.ID}`);
  };

  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid " id="skill-table-area">
            <div className="box-body table-responsive container-fluid ">
              <div className="row mt-2">
                <NewDynamic_PR_table
                  data={reportList}
                  columns={columns}
                  defaultColumns={defaultColumns}
                  itemsPerPage={8}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  showIcon1={false}
                  showIcon2={false}
                  showIcon3={true}
                  showIcon4={false}
                  showIcon5={false}
                  responseStatus={respStatus}
                  formDatas={formDatas}
                  isSorting={true}
                  filterFormData={filterFormData}
                  handleGetData={handleGetData}
                  isActionRequired={true}
                  isFilterRequired={true}
                  isCheckBoxRequired={false}
                  // handleIcon1={handleEdit}
                  handleIcon3={handleView}
                  // handleIcon4={handleOpen}
                  handleChange={handleChange}
                  add
                  more
                  function
                  icons={{
                    Icon1: <i class="bi bi-pencil-square  icons"></i>,
                    Icon2: <i class="bi bi-trash-fill icons"></i>,
                    Icon3: <i class="bi bi-eye-fill icons"></i>,
                    Icon4: <i class="bi bi-person-plus icons"></i>,
                    Icon4Text: "Create Employee",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default PR_Status;
